import styled from 'styled-components';

export const SMSConfirmModal = styled.div<{ $centered?: boolean }>`
    line-height: normal;
    padding: 0 20px 10px;
    min-height: 230px;
    width: 100%;
    ${({ $centered }) => $centered && `
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `}
`;

export const SMSConfirmDesc = styled.pre`
    ${({ theme }) => theme.text.normal};
`;

export const SMSConfirmInputDesc = styled.p`
    ${({ theme }) => theme.text.small};
    color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SMSConfirmWaitingText = styled.p`
    ${({ theme }) => theme.text.small};
    color: ${({ theme }) => theme.colors.primary};
`;

export const SMSConfirmResendTimer = styled.div<{ $clickable?: boolean }>`
    padding: 10px 0;
    ${({ theme }) => theme.text.normal};
    color: ${({ theme }) => theme.colors.link};
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const Controls = styled.div`
  display: flex;
  justify-content: end;
`;
